import { getCachedUser } from 'lib/network/webapi';
import _debug from 'debug';

export const FETCH_USER_NAME = 'FETCH_USER_NAME';

const debug = _debug('app:statetopbar');

const initialState = {
  username: ''
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_USER_NAME:
      return {
        ...state,
        username: action.payload
      };
    default:
      return state;
  }
}

export const getUserName = () => {
  const user = getCachedUser();
  debug('What is the cached user ', user);
  return {
    type: FETCH_USER_NAME,
    // payload: user && user.profile && user.profile.name
    payload: user && user.name
  };
};



// WEBPACK FOOTER //
// ./src/state/modules/topBar.js